const isCalloutExtension = (ext) => ext._type === 'Ads/CalloutExtension';

export const hasCalloutExtension = (extensions = []) => extensions.some(isCalloutExtension);

export const getCalloutExtension = (extensions = []) => extensions.find(isCalloutExtension);

export const getCallout = ({ callout = '' }) => callout;
